import {Checkbox, TableCell, TableRow} from '@material-ui/core';
import TableWithCheckboxes from '../../../../../../../ui/tables/table-with-checkboxes/TableWithCheckboxes';
import {returnSelectedRows} from "../../../../../../../../shared/utils/tableUtils";
import {useSelector} from "react-redux";
import {dateConvertedItalianWithFirstCapitalMonth} from "../../../../../../../../shared/utils/dateUtils";
import EmptyRow from "../../../../../../../ui/tables/rows/empty-row/EmptyRow";
import PropTypes from "prop-types";
import {headCells} from "./SimDaAttivareHeadCells";
import React from "react";
import HourglassIconAndTooltipCell
    from "../../../../../../../ui/tables/cells/hourglass-icon-and-tooltip-cell/HourglassIconAndTooltipCell";
import {getSimTableTooltipContent} from "../../../../../../../../shared/utils/utils";

const DaAttivareTable = (props) => {
    const tableData = useSelector((state) => state.ordiniConsipReducer.simDaAttivare)
    const loading = useSelector((state) => state.ordiniConsipReducer.daAttivareLoading)

    const handleOnClick = (event, sim) => {
        event.stopPropagation();
        props.setAreAllSelected(false)
        const selectedIndex = props.selected.findIndex(i => i.seriale === sim.seriale);
        props.setSelected(returnSelectedRows(props.selected, sim, selectedIndex));
    };

    const isSelected = (seriale) => props.selected.some(s => s.seriale === seriale);


    const tableRows = (
        tableData.count !== 0 ? tableData.data.map((row, index) => {
            const isItemSelected = isSelected(row.seriale);
            const labelId = `sim-da-attivare-table-${index}`

            return (
                <TableRow
                    hover
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={row.seriale}
                    onClick={(e) => handleOnClick(e, row)}
                    selected={isItemSelected}>
                    <TableCell padding="checkbox">
                        <Checkbox
                            checked={isItemSelected}
                            onClick={(e) => handleOnClick(e, row)}
                            inputProps={{'aria-labelledby': labelId}}
                        />
                    </TableCell>
                    <TableCell scope="row" padding="none">
                        {row.numeroDiTelefono}
                    </TableCell>
                    <TableCell align="left">{row.seriale}</TableCell>
                    <TableCell>{dateConvertedItalianWithFirstCapitalMonth(row.dataOrdineDiConsegna)}</TableCell>
                    <TableCell>{row.numeroOrdineDiConsegna}</TableCell>
                    <TableCell align="right" className="wrench-tooltip-cell">
                        {row.wrenchDto.showWrench ? <HourglassIconAndTooltipCell
                            tooltipContent={getSimTableTooltipContent(row.wrenchDto)}/> : null}
                    </TableCell>
                </TableRow>
            )
        }) : <EmptyRow text="dato" colSpan={headCells.length + 2}/>)

    return (
        <TableWithCheckboxes selected={props.selected}
                             setSelected={props.setSelected}
                             page={props.page}
                             fetchData={props.handlePaginationChange}
                             rowsPerPage={props.rowsPerPage}
                             rows={tableData.data}
                             tableRows={tableRows}
                             headCells={headCells}
                             count={tableData.count}
                             loading={loading}
                             selectAllRows={props.areAllSelected}
                             setSelectAllRows={props.setAreAllSelected}/>
    )
}

DaAttivareTable.propTypes = {
    selected: PropTypes.array.isRequired,
    setSelected: PropTypes.func.isRequired,
    areAllSelected: PropTypes.bool.isRequired,
    setAreAllSelected: PropTypes.func.isRequired,
    handlePaginationChange: PropTypes.func.isRequired,
}

export default DaAttivareTable
